module.exports = __webpack_public_path__ + "static/Roboto-Thin-d1e42f1b6d0c32271f8e68515563a213.ttf";